import { gql } from 'apollo-boost';

export const moveToPortfolioMutation = gql`
  mutation moveToPortfolioMutation($id: Int!, $portfolioId: Int!) {
    updateInvestment(id: $id, portfolioId: $portfolioId) {
      success
      id
      error
    }
  }
`;
